function moveJumplinks() {
  const elements = [
    ...document.querySelectorAll<HTMLElement>(
      "article a[name]:not([href]), article h2, article h3, article h4",
    ),
  ];

  const jumplinks = document.querySelectorAll<HTMLAnchorElement>(
    "article a[name]:not([href])",
  );

  jumplinks.forEach((jumplink) => {
    const jumplinkIndex = elements.indexOf(jumplink);

    const title = elements.find(
      (elem, index) =>
        index > jumplinkIndex && ["H2", "H3", "H4"].includes(elem.tagName),
    );

    if (title) {
      title.before(jumplink);
    }
  });
}

export { moveJumplinks };
